export { default as ViewListQuestionSolidIcon } from './ViewListQuestionSolidIcon';
